// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"66634a82","453":"d855a71b","840":"8f45a8f4"}[chunkId] + ".chunk.js";
};